import React from 'react';
import {
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    useMediaQuery
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { IconCaretRightFilled } from '@tabler/icons-react';
import { useNavigate, Link } from 'react-router-dom';

const PerformanceReviewTemplatesTable = ({ templates }) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>{t(StringKeys.TEMPLATE_NAME)}</TableCell>
                        {isMobile && <TableCell></TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {templates.map((template) => (
                        <TableRow
                            onClick={() => {
                                !isMobile && navigate(`/performance-review-templates/${template.id}`);
                            }}
                            style={{ cursor: !isMobile ? 'pointer' : 'default' }}
                            key={template.id}
                        >
                            <TableCell>{template.name}</TableCell>
                            {isMobile && 
                                <TableCell sx={{textAlign:"end"}}>
                                    <IconButton
                                        component={Link}
                                        to={`/performance-review-templates/${template.id}`}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <IconCaretRightFilled />
                                    </IconButton>
                                </TableCell>
                            }
                        </TableRow>
                    ))}
                    {templates.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                {t(StringKeys.NO_TEMPLATES_TO_DISPLAY)}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PerformanceReviewTemplatesTable;
